export const scrollToTop = () => {
  try {
    setTimeout(() => window.scrollTo({ top: 0 }));
  } catch (error) {
    window.scrollBy({ top: 0 });
  }
};
